import "./Features.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import TheUniversalMetaRuntime from "./sections/TheUniversalMetaRuntime";
import FeaturesGrid from "./sections/FeaturesGrid";
import ReadyToTakeControl from "./sections/ReadyToTakeControl";
export default function FeaturesPage() {
  return <div>
      <FraternalExcellenceHeader />
      <TheUniversalMetaRuntime />
      <FeaturesGrid />
      <ReadyToTakeControl />
      <Footer />
    </div>;
}